import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { extendedPanel, extendedPanelWithLocalId, PanelType } from '@atlaskit/adf-schema';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { FORMAT_MENU_ITEM, FORMAT_PANEL_MENU_ITEM, FORMAT_NESTED_MENU_RANK, FORMAT_NESTED_MENU_RANK_REVISED } from '@atlaskit/editor-common/block-menu';
import { insertSelectedItem } from '@atlaskit/editor-common/insert';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { IconCustomPanel, IconPanel, IconPanelError, IconPanelNote, IconPanelSuccess, IconPanelWarning } from '@atlaskit/editor-common/quick-insert';
import { createWrapSelectionTransaction } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
import { T50 } from '@atlaskit/theme/colors';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { insertPanelWithAnalytics } from './editor-actions/actions';
import keymap from './pm-plugins/keymaps';
import { createPlugin } from './pm-plugins/main';
import { createPanelBlockMenuItem } from './ui/panelBlockMenuItem';
import { getToolbarConfig } from './ui/toolbar';
var panelPlugin = function panelPlugin(_ref) {
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  if (expValEqualsNoExposure('platform_editor_block_menu', 'isEnabled', true)) {
    var _api$blockMenu;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([{
      type: 'block-menu-item',
      key: FORMAT_PANEL_MENU_ITEM.key,
      parent: {
        type: 'block-menu-section',
        key: FORMAT_MENU_ITEM.key,
        rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_PANEL_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_PANEL_MENU_ITEM.key]
      },
      component: createPanelBlockMenuItem(api)
    }]);
  }
  return {
    name: 'panel',
    nodes: function nodes() {
      if (fg('platform_editor_adf_with_localid')) {
        if (fg('platform_editor_ai_aifc_patch_beta')) {
          return [{
            name: 'panel',
            node: _objectSpread(_objectSpread({}, extendedPanelWithLocalId(!!options.allowCustomPanel)), {}, {
              definingAsContext: true
            })
          }];
        }
        return [{
          name: 'panel',
          node: extendedPanelWithLocalId(!!options.allowCustomPanel)
        }];
      }
      return [{
        name: 'panel',
        node: extendedPanel(!!options.allowCustomPanel)
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'panel',
        plugin: function plugin(_ref2) {
          var providerFactory = _ref2.providerFactory,
            dispatch = _ref2.dispatch,
            nodeViewPortalProviderAPI = _ref2.nodeViewPortalProviderAPI;
          return createPlugin(dispatch, providerFactory, options, api, nodeViewPortalProviderAPI);
        }
      }, {
        name: 'panelKeyMap',
        plugin: function plugin() {
          return keymap();
        }
      }];
    },
    actions: {
      insertPanel: function insertPanel(inputMethod) {
        if (expValEquals('platform_editor_fix_quick_insert_consistency_exp', 'isEnabled', true)) {
          return function (state, dispatch) {
            var tr = createPanelAction({
              state: state,
              attributes: {
                panelType: PanelType.INFO
              },
              api: api,
              inputMethod: inputMethod
            });
            if (!tr) {
              return false;
            }
            if (dispatch) {
              dispatch(tr);
            }
            return true;
          };
        } else {
          var _api$analytics;
          return insertPanelWithAnalytics(inputMethod, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
        }
      }
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        if (editorExperiment('platform_editor_insertion', 'variant1')) {
          return [{
            id: 'infopanel',
            title: formatMessage(blockTypeMessages.infoPanel),
            keywords: ['panel'],
            description: formatMessage(blockTypeMessages.infoPanelDescription),
            priority: 800,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanel, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.INFO
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }];
        } else {
          var quickInsertOptions = [{
            id: 'infopanel',
            title: formatMessage(blockTypeMessages.infoPanel),
            keywords: ['panel'],
            description: formatMessage(blockTypeMessages.infoPanelDescription),
            priority: 800,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanel, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.INFO
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }, {
            id: 'notepanel',
            title: formatMessage(blockTypeMessages.notePanel),
            description: formatMessage(blockTypeMessages.notePanelDescription),
            priority: 1000,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanelNote, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.NOTE
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }, {
            id: 'successpanel',
            title: formatMessage(blockTypeMessages.successPanel),
            description: formatMessage(blockTypeMessages.successPanelDescription),
            keywords: ['tip'],
            priority: 1000,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanelSuccess, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.SUCCESS
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }, {
            id: 'warningpanel',
            title: formatMessage(blockTypeMessages.warningPanel),
            description: formatMessage(blockTypeMessages.warningPanelDescription),
            priority: 1000,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanelWarning, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.WARNING
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }, {
            id: 'errorpanel',
            title: formatMessage(blockTypeMessages.errorPanel),
            description: formatMessage(blockTypeMessages.errorPanelDescription),
            priority: 1000,
            icon: function icon() {
              return /*#__PURE__*/React.createElement(IconPanelError, null);
            },
            action: function action(typeAheadInsert, state) {
              return createPanelAction({
                state: state,
                attributes: {
                  panelType: PanelType.ERROR
                },
                api: api,
                typeAheadInsert: typeAheadInsert
              });
            }
          }];
          if (options.allowCustomPanel && options.allowCustomPanelEdit) {
            quickInsertOptions.push({
              id: 'custompanel',
              title: formatMessage(blockTypeMessages.customPanel),
              description: formatMessage(blockTypeMessages.customPanelDescription),
              priority: 1000,
              icon: function icon() {
                return /*#__PURE__*/React.createElement(IconCustomPanel, null);
              },
              action: function action(typeAheadInsert, state) {
                return createPanelAction({
                  state: state,
                  attributes: {
                    panelType: PanelType.CUSTOM,
                    panelIcon: ':rainbow:',
                    panelIconId: '1f308',
                    panelIconText: '🌈',
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                    panelColor: T50
                  },
                  api: api,
                  typeAheadInsert: typeAheadInsert
                });
              }
            });
          }
          return quickInsertOptions;
        }
      },
      floatingToolbar: function floatingToolbar(state, intl, providerFactory) {
        return getToolbarConfig(state, intl, options, providerFactory, api);
      }
    }
  };
};

/**
 * Creates panel action and wrap selection transaction with analytics for the panel insertion.
 *
 * @example
 * const tr = createPanelAction({
 *   state: editorState,
 *   attributes: { panelType: 'info' },
 * });
 * if (tr) {
 *   applyTransaction(tr);
 * }
 */
function createPanelAction(_ref4) {
  var state = _ref4.state,
    attributes = _ref4.attributes,
    api = _ref4.api,
    typeAheadInsert = _ref4.typeAheadInsert,
    _ref4$inputMethod = _ref4.inputMethod,
    inputMethod = _ref4$inputMethod === void 0 ? INPUT_METHOD.QUICK_INSERT : _ref4$inputMethod;
  var panel = state.schema.nodes.panel;
  var tr;
  /*
  	During investigation of go/j/ED-26928 I found that the behaviour of this experience was very
  	inconsistent. I reached out to Nicole* for a design review, and she confirmed that the desired
  	behaviour is to insert the panel on a new line if the selection is empty.
  	 *Confluence Editor Lead Product Designer
   */
  if (expValEquals('platform_editor_fix_quick_insert_consistency_exp', 'isEnabled', true)) {
    // If the selection is empty, we want to insert the panel on a new line
    if (state.selection.empty) {
      var node = panel.createAndFill(_objectSpread({}, attributes));
      if (!node) {
        return false;
      }
      if (typeAheadInsert !== undefined) {
        // If the type-ahead insert is provided, we should use that to insert the node
        tr = typeAheadInsert(node);
      } else {
        var _insertSelectedItem;
        // Otherwise we can use insertSelectedItem to insert the node
        tr = (_insertSelectedItem = insertSelectedItem(node)(state, state.tr, state.selection.head)) === null || _insertSelectedItem === void 0 ? void 0 : _insertSelectedItem.scrollIntoView();
      }
    } else {
      tr = createWrapSelectionTransaction({
        state: state,
        type: panel,
        nodeAttributes: _objectSpread({}, attributes)
      });
    }
  } else {
    // Panels should wrap content by default when inserted, the quickInsert `insert` method
    // will insert the node on a newline
    if (editorExperiment('platform_editor_controls', 'variant1')) {
      tr = state.selection.empty && createWrapSelectionTransaction({
        state: state,
        type: panel,
        nodeAttributes: _objectSpread({}, attributes)
      });
    } else {
      var _node = panel.createAndFill(_objectSpread({}, attributes));
      if (!_node) {
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This is only optional within the experiment, so safe to assume non-null here
      tr = state.selection.empty && typeAheadInsert(_node);
    }
  }
  if (tr) {
    var _api$analytics2;
    api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
      action: ACTION.INSERTED,
      actionSubject: ACTION_SUBJECT.DOCUMENT,
      actionSubjectId: ACTION_SUBJECT_ID.PANEL,
      attributes: {
        inputMethod: inputMethod,
        panelType: attributes.panelType
      },
      eventType: EVENT_TYPE.TRACK
    })(tr);
  }
  return tr !== null && tr !== void 0 ? tr : false;
}
export default panelPlugin;